// One capture step as the person filling it in will see it.
//
// SHARED between the two apps — the editor (app/code) previews through it and
// the fill app (app/fill) captures through it — which is why it lives in
// app/shared rather than in either src/. The fill app must never import
// through app/code/src: app/code/node_modules sits on that walk-up path and
// would hand the fill bundle a second React. app/shared has no node_modules
// above it, so its imports fall through to whichever app is building. Keep
// every import here to @repoflow/* and @common/*.
//
// A step's params are a DECLARATION; the form is compiled out of them at render
// time by @repoflow/components/types-values, which is the same runtime pagews
// compiles a section's values form with. The adaptation between the two is
// `stepTypes` in @common/schema/types: one type, called root, holding the
// step's params.
//
// `subforms` are the workflow's: an `object` field on the step names one, and
// the compiled schema has to carry it. The caller is expected to have asked
// `missingSubforms` first — a dangling name throws from inside the render.
//
// The values live wherever the caller keeps them. On the editor's Preview tab
// that is local state that is thrown away — nothing here is a capture yet,
// and this component is deliberately the piece that will not change when one
// exists: the capture path will hand it real values and a real onSubmit.
import React from "react";
import { Form as ValuesForm } from "@repoflow/components/types-values";
import StepsSchema, { stepTypes } from "@common/schema/types";

export const Form = ({ step, subforms, values, onChange, onSubmit, widgets, readOnly = false, children }) => (
  <ValuesForm
    types={stepTypes(step, subforms)}
    values={values}
    onChange={onChange}
    onSubmit={onSubmit}
    widgets={widgets}
    // The generated schema may reference /Name and friends by $ref. Passing
    // the shared fragments in means a param can use them without types-values
    // knowing they exist.
    utils={StepsSchema}
    readOnly={readOnly}
  >
    {children}
  </ValuesForm>
);
